// Farb-Karten speichern ihre Grafik als JSON ('{"Farbe":…,"QR_Code":…}')
// statt als Bild-URL. Reines JS ohne React-Abhängigkeit, damit die
// Backend-Suite es testen kann.

/**
 * Liefert die Farbdaten einer Kartenseite oder null, wenn der Wert keine
 * Farb-Grafik ist. Ein kaputter Wert ergibt ebenfalls null statt eines
 * Render-Fehlers, der die ganze Ansicht abreissen würde — die Aufrufer zeigen
 * ihn dann wie eine Bild-URL an.
 */
export const parseColorGraphic = (value) => {
  if (typeof value !== 'string' || !value.startsWith('{"Farbe')) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
